import type { ReactNode } from 'react';

/**
 * Two-column context row — user profile on the left, operation metadata on
 * the right. Renders a single full-width card if only one child is given.
 *
 * See docs/FeatureDesigns/operation-detail-unified-layout.md.
 */
export interface ContextGridProps {
    left: ReactNode;
    right?: ReactNode;
}

export function ContextGrid({ left, right }: ContextGridProps) {
    if (!right) {
        return <>{left}</>;
    }
    return (
        <div className="row-two-cols">
            {left}
            {right}
        </div>
    );
}
